import { orderHelper } from "@shop/frontend/web/js/helpers/OrderHelper";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import { helpers } from "@shop/frontend/web/js/helpers";

export class EventOrderView {
	constructor() {
		this.$eventSum = $("#js-event-sum");
		this.$ticketsItems = $("#js-tickets-items");

		this.$placesBuy = $("#js-places-buy");
		this.$tickets = $(".js-tickets");

		this.ticketTemplate = $("#js-ticket-template")[0];
	}

	/**
	 * Рендерит заказ мероприятия
	 * @param order {Object} - Модель заказа
	 */
	render(order) {
		this.$eventSum.text(order.amount);

		this.$ticketsItems.html("");
		$.each(order.carts, (i, cart) => {
			let sector = translator.t("event", cart.sector) || cart.view_id;
			if (sector) {
				sector =
					!cart.is_pack && !cart.hide
						? translator.t("main", "Sector") + " " + sector
						: translator.t("event", cart.sector);
			}

			cart.name = `${translator.t("main", "Row")} ${cart.row} ${translator.t(
				"main",
				"place"
			)} ${cart.col}`;

			this.$ticketsItems.append(
				orderHelper.insertDataToTicket(
					$(document.importNode(this.ticketTemplate.content, true)),
					{
						...cart,
						sector,
						order_id: order.id,
					}
				)
			);
		});

		this.renderCount(order.carts.length);
	}

	renderCount(count) {
		$(".js-count-event").text(count);
		$(".js-count-word").text(
			helpers.wordEnding(count, [
				translator.t("event", "ticket"),
				translator.t("event", "tickets"),
				translator.t("event", "tickets "),
			])
		);
	}
}
